export default __webpack_public_path__ + "static/media/openpage.d6ef5a68.png";